var map = {
	"./carrefourlogo.png": 6866,
	"./cyberarklogo.png": 9246,
	"./elbitlogo.png": 7891,
	"./keshetlogo.png": 6698,
	"./keshetlogo2.png": 4751,
	"./mobileyelogo.png": 286,
	"./tevalogo.png": 9386,
	"./tevalogo2.png": 2606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8948;